/*! Copyright (c) Safe As Milk. All rights reserved. */
function tabClick(e) {
    if (e.keyCode === 9) {
        document.body.classList.add("js-using-tab");
        window.removeEventListener("keydown", tabClick);
    }
}

window.addEventListener("keydown", tabClick);

window.theme ??= {};

window.theme.wrapRteTables = (rootElement = document) => {
    const wrapTable = (el, wrapper) => {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    };
    rootElement.querySelectorAll(".rte table").forEach((table => {
        if (table.closest(".js-theme-utility-rte-table-wrap")) return;
        const tableWrapper = document.createElement("div");
        tableWrapper.classList.add("js-theme-utility-rte-table-wrap");
        tableWrapper.setAttribute("style", "overflow:auto;-webkit-overflow-scrolling:touch");
        wrapTable(table, tableWrapper);
    }));
};

window.theme.wrapRteTables();

const scrollEndSupported = typeof window === "undefined" ? true : "onscrollend" in window;

if (!scrollEndSupported) {
    import("scrollyfills");
}
//# sourceMappingURL=global.js.map

// product endorsement video
document.addEventListener("DOMContentLoaded", function () {
  var Eventswiper = new Swiper(".product-endorsement-vehicle_swiper", {
    spaceBetween: 25,
    breakpoints: {
      320: {
        slidesPerView: 1.4,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2.4,
        spaceBetween: 20,
      },
      912: {
        slidesPerView: 3.1,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3.4,
        spaceBetween: 20,
      },
      1380: {
        slidesPerView: 3.8,
        spaceBetween: 20,
      },
      1580: {
        slidesPerView: 4.5,
        spaceBetween: 30,
      },
    },
    pagination: {
      el: ".product-endorsement-events-pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".product-endorsement-events-next",
      prevEl: ".product-endorsement-events-prev",
    },
    watchOverflow: true,
  });

  var swiperProgress = new Swiper(".progressSwiper", {
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    slidesPerView: 1.2,
    spaceBetween: 20,
    breakpoints: {
      1920: {
        slidesPerView: 3.5,
      },
      1028: {
        slidesPerView: 3.5,
      },
      768: {
        slidesPerView: 1.2,
      },
      480: {
        slidesPerView: 1.3,
      },
    }
  });



});





// Gift tab
document.addEventListener("DOMContentLoaded", function () {
  $(document).ready(function () {
    $(".product-switcher").click(function () {
      let index = $(this).parent().index();
      $(".product-switcher").removeClass("lg-active");
      $(this).addClass("lg-active");
      $(".products-switcher__bundling").addClass("bundles-hide");
      $(".products-switcher__bundling").eq(index).removeClass("bundles-hide");
    });
  });
});

function toggleShowed() {
  var bundlesText = document.querySelector(".product-discount-shower-bundling");
  var bundlesbutton = document.querySelector(".product-bundles-bespeak-item");
  var bundlesbtnstext = document.querySelector(".product-bundles-btns-text");
  var BundlesDown = document.querySelector(".BundlesDown-icon");

  if (bundlesText.classList.contains("expanded")) {
    bundlesText.classList.remove("expanded");
    bundlesbtnstext.textContent = "Show more";
    BundlesDown.classList.remove("up");
  } else {
    bundlesText.classList.add("expanded");
    bundlesbtnstext.textContent = "Show less";
    BundlesDown.classList.add("up");
  }
}

